import serviceGrupoOpcion from '@/services/GsEncuesta/grupoOpcion'

export default {
  GRUPO_OPCION_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceGrupoOpcion.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  GRUPO_OPCION_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceGrupoOpcion.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  GRUPO_OPCION_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceGrupoOpcion.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  GRUPO_OPCION_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceGrupoOpcion.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
